import i18n from "i18next";
export const templatesSliDoc = () => {
  return [
    {
      name: "Test",
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "90%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: i18n.t("templates.template2"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "5%",
            y: "52.5%",
            width: "90%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
  ];
};

export const templatesSli = () => {
  return [
    {
      name: i18n.t("templates.template1"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: i18n.t("templates.template1"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "90%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: i18n.t("templates.template2"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "5%",
            y: "52.5%",
            width: "90%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: i18n.t("templates.template2"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "5%",
            y: "52.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
        {
          box: {
            x: "5%",
            y: "58.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
        {
          box: {
            x: "5%",
            y: "64.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
        {
          box: {
            x: "5%",
            y: "70.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
        {
          box: {
            x: "5%",
            y: "76.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
        {
          box: {
            x: "5%",
            y: "82.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
        {
          box: {
            x: "5%",
            y: "88.5%",
            width: "90%",
            height: "2%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "#fdfffd",
            color: "#d6d6d6",
          },
        },
      ],
    },
    {
      name: i18n.t("templates.template3"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "42.5%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "52.5%",
            y: "52.5%",
            width: "42.5%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "5%",
            y: "52.5%",
            width: "42.5%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "52.5%",
            y: "5%",
            width: "42.5%",
            height: "42.5%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
  ];
};

export const templatesDoc = () => {
  return [
    {
      name: i18n.t("templates.template1"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "90%",
            height: "90%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
    {
      name: i18n.t("templates.template2"),
      boxes: [
        {
          box: {
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#ffffff",
          },
        },
        {
          box: {
            x: "5%",
            y: "5%",
            width: "42.5%",
            height: "90%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
        {
          box: {
            x: "52.5%",
            y: "5%",
            width: "42.5%",
            height: "90%",
          },
          toolbar: {
            name: "BasicText",
            text: "<h1 class='no_margins'>" + i18n.t("templates.ex_true_false") + "</h1>",
          },
          thumbnail: {
            icon: "",
            icon_color: "",
            color: "#B2B2B2",
          },
        },
      ],
    },
  ];
};
